import { render, staticRenderFns } from "./AddAddressModal.vue?vue&type=template&id=ba0c78e0&"
import script from "./AddAddressModal.vue?vue&type=script&lang=ts&"
export * from "./AddAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba0c78e0')) {
      api.createRecord('ba0c78e0', component.options)
    } else {
      api.reload('ba0c78e0', component.options)
    }
    module.hot.accept("./AddAddressModal.vue?vue&type=template&id=ba0c78e0&", function () {
      api.rerender('ba0c78e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/address/AddAddressModal.vue"
export default component.exports